export default __webpack_public_path__ + "static/media/Eamon-Miller.988f85fc.pdf";